module.exports = __webpack_public_path__ + "assets/import-emails.629e9507.svg";